import { render, staticRenderFns } from "./ModalRemoveSupervisorWithCollaborators.vue?vue&type=template&id=6f449f95&scoped=true&"
import script from "./ModalRemoveSupervisorWithCollaborators.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveSupervisorWithCollaborators.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemoveSupervisorWithCollaborators.vue?vue&type=style&index=0&id=6f449f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f449f95",
  null
  
)

export default component.exports